/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

import React, { useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import { useLocation, useNavigate } from "react-router-dom";
import { getContentHeight } from "../utils/utils";
import Feedback from "../features/feedback/Feedback";
import welcomeImage from "../welcome-screen.jpg"

function WelcomeScreen() {
  const feedbackRef = useRef();
  const [menuHeight, setMenuHeight] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const handleWindowSizeChange = () => {
    setMenuHeight(getContentHeight());
  };

  const itemCustomizationStyle = {
    overflow: "auto",
    width: "100vw",
    height: menuHeight,
    backgroundImage: `url(${welcomeImage})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "bottom",
    display: "flex",
    flexGrow: 1,
  };

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (Object.prototype.hasOwnProperty.call(location, "state")) {
      const { state } = location;
      if (state != null) {
        feedbackRef.current.openFeedbackDialog();
        navigate(`/WELCOME_VIEW`, { replace: true });
      }
    }
  }, [location]);

  return (
    <Grid
      sx={itemCustomizationStyle}
      container
      justifyContent='center'
      alignItems='center'
    >
      <Feedback ref={feedbackRef} />
    </Grid>
  );
}

export default WelcomeScreen;
